import React, {memo, useEffect} from 'react'
import {useSafeState} from '../../hook'
import {withHelmet, withMeData, withPropsPresent, withSubscriptionData} from '../../hoc'
import {userAccount, userIsBillingOwner} from '../../util'
import {Grid, Loader} from 'semantic-ui-react'
import {SelectPlan} from './select-plan'
import {PaymentMethod} from './payment-method'
import {SubscriptionSummary} from './subscription-summary'
import {Invoices} from './invoices'


const _Billing = (
  {
    me,
    subscription,
    navigate
  }
) => {
  const [state, setState] = useSafeState({stripeLoaded: false, subscription})

  useEffect(() => {
    const stripeJs = document.createElement('script')
    stripeJs.src = 'https://js.stripe.com/v3/'
    stripeJs.async = true
    stripeJs.onload = () => {
      setState({...state, subscription, stripeLoaded: true})
    }
    document.body && document.body.appendChild(stripeJs)
  }, [])

  const onSubscriptionUpdated = (subscription) => {
    setState({...state, subscription: subscription || state.subscription})
  }

  const account = userAccount(me, false)

  if (!state.stripeLoaded) {
    return <Loader active inline='centered'>Loading billing info...</Loader>
  }

  return (
    <Grid divided='vertically'>
      <Grid.Row columns='16'>
        <Grid.Column width='16'>
          <SelectPlan navigate={navigate} account={account} subscription={state.subscription}
                      onSubscriptionUpdated={onSubscriptionUpdated}/>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns='16'>
        <Grid.Column width='16'>
          <SubscriptionSummary navigate={navigate} subscription={state.subscription}/>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns='16'>
        <Grid.Column width='16'>
          <PaymentMethod navigate={navigate} subscription={state.subscription} me={me}
                         onSubscriptionUpdated={onSubscriptionUpdated}/>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns='16'>
        <Grid.Column width='16'>
          <Invoices navigate={navigate} subscription={state.subscription}/>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  )
}


let Billing = (props) => {
  // useScript({
  //   src: 'https://js.stripe.com/v3/'
  // })
  const {me, navigate} = props
  if (!userIsBillingOwner(me)) {
    navigate('/c/account')
    return null
  }
  props = {...props, navigate}
  return (<_Billing {...props}/>)
}


Billing = withHelmet(Billing, 'Billing')
Billing = withPropsPresent(Billing, ['me', 'subscription'])
Billing = withMeData(Billing, 'Loading profile...')
Billing = withSubscriptionData(Billing, 'Loading billing info...')
Billing = memo(Billing)

export {Billing, _Billing}

export default Billing